export default __webpack_public_path__ + "static/media/Mountains-Outer-Space-Wallpapers.94f6ffc7.jpg";